import React from 'react';
import { Menu, LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import { Avatar, AvatarFallback } from '../ui/avatar';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { getCorPerfil, getNomePerfil } from '../../utils/permissoes';
import { produtoDaUrl } from '../../config/produtoDaUrl';
import SaldoDisparos from './SaldoDisparos';

export function MarcaProduto() {
  return (
    <span className="flex items-center gap-2 font-display text-lg font-semibold tracking-tight text-blue-950 select-none">
      <img src="/integrai-marca.png" alt="" className="h-7 w-auto" />
      <span>IntegrAI <span className="text-blue-600">{produtoDaUrl().sufixo}</span></span>
    </span>
  );
}

function MenuUsuario({ usuario, perfil, onLogout }) {
  const iniciais = usuario
    ? usuario.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
    : 'U';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-2 text-blue-950 bg-white shadow-sm hover:bg-slate-50 h-10 px-3 rounded-full">
          <Avatar className="h-7 w-7">
            <AvatarFallback className="text-xs font-semibold bg-blue-50 text-blue-700">{iniciais}</AvatarFallback>
          </Avatar>
          <span className="hidden sm:block text-sm font-semibold">{usuario}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-0.5">
            <p className="text-sm font-medium">{usuario}</p>
            <p className="text-xs" style={{ color: getCorPerfil(perfil) }}>
              {getNomePerfil(perfil)}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onLogout} className="text-red-600 focus:text-red-600 focus:bg-red-50">
          <LogOut className="h-4 w-4" />
          Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

/**
 * Cabeçalho da página no desenho do Finance: etiqueta com a empresa, título grande
 * e, à direita, as pílulas (saldo e usuário). Não há barra de topo; a marca fica no menu.
 */
export default function CabecalhoPagina({ tenantId, tenantNome, titulo, usuario, perfil, onLogout, onMenuClick }) {
  return (
    <header className="flex items-start justify-between gap-4 px-6 lg:px-8 pt-6 lg:pt-8 shrink-0">
      <div className="flex items-start gap-3 min-w-0">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden text-slate-600 hover:bg-slate-100 -ml-2"
          onClick={onMenuClick}
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="min-w-0">
          {tenantNome && (
            <span className="inline-block max-w-full truncate rounded-full bg-blue-50 border border-blue-100 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-blue-700">
              {tenantNome}
            </span>
          )}
          {titulo && (
            <h1 className="mt-2 font-display text-2xl lg:text-[28px] font-semibold leading-tight text-blue-950 truncate">{titulo}</h1>
          )}
        </div>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <SaldoDisparos tenantId={tenantId} />
        <MenuUsuario usuario={usuario} perfil={perfil} onLogout={onLogout} />
      </div>
    </header>
  );
}
